<template lang="pug">

    div
        h5
            | Proof
            a.edit(v-if="$route.name !== 'quality-rating'" v-on:click='$refs.modal.show()'): i.edit.icon

        div(v-if="hasProof")
            table.ui.small.fixed.very.basic.table
                tr
                    th Art
                    td Hardproof
                tr
                    th Vorauftragsmuster verwenden (ID)
                    td {{ previousJob }}
                tr
                    th Format
                    td {{ format }}
                tr
                    th Bemerkung
                    td {{ note }}

        p(v-else) Nein

        modal(ref="modal")
            p(slot="header") Proof bearbeiten

            form(slot="content").ui.form
                proof-form(
                    v-bind:shipping-address-models='shippingAddressModels'
                    v-model='model'
                )

            action-row(slot="footer" v-on:cancel="$refs.modal.close()" v-on:save="persist()")


</template>

<script>
    import * as R from 'ramda'
    import { format_to_readable } from '@/utils/proof'
    import { default_to } from '@/utils/string'
    import Modal from '@/components/app/Modal'
    import ActionRow from '@/components/form/ActionRow'
    import ProofForm from '@/components/products/forms/ProofForm'

    export default {
        name: 'products-view-proof-details',

        components: { ActionRow, Modal, ProofForm },

        computed: {

            format() {
                return format_to_readable(this.proofModel.format)
            },

            hasProof() {
                return R.cond([
                    [R.isNil, R.always(false)],
                    [R.propEq('isWanted', 'NO'), R.always(false)],
                    [R.T, R.always(true)]
                ])(this.proofModel)
            },

            note() {
                return default_to('-', this.proofModel.note)
            },

            previousJob() {
                return default_to('-', this.proofModel.previousJob)
            },

        },

        data() {
            return {
                model: R.clone(this.proofModel)
            }
        },

        methods: {

            persist() {
                this.$store.dispatch('proofs/update', { model: this.model })
                    .then(() => this.$growl.success('Proof wurde gespeichert'))
                    .then(this.$refs.modal.close)
                    .catch(e => this.$growl.fatal('Proof konnte nicht gespeichert werden', e))
            }

        },

        props: {

            proofModel: {
                type: Object,
                required: true
            },

            shippingAddressModels: {
                type: Array,
                required: true
            }

        }

    }

</script>

<style scoped>

    th, td {
        border-top: 1px solid rgba(34,36,38,.1);
    }

    table tr:first-child th, table tr:first-child td {
        border-top: none
    }

    a.edit {
        cursor: pointer;
        float: right;
    }

</style>
